import { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  Grid, TextField, MenuItem, Button,
  Typography, FormGroup, FormControlLabel,
} from "@mui/material";
import { LocalTaxiRounded, ScheduleRounded, ChecklistRtlRounded } from "@mui/icons-material";
import { useMapsLibrary } from '@vis.gl/react-google-maps';
import countryCodeData from "./countryCode/index.json";
import CustomSwitch from "SharedComponents/CustomSwitch";
import { useFormik, useField } from "formik";
import * as yup from "yup";
import Assigndriver from "./Assigndriver";
// Redux
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";

//Services
import DispatcherApi from "Services/Dispatcher";

const CreateTrip = ({
  destination, dropLatLng, pickupLatLng, distance, travelDuration, origin,
  activecarouselRef, userType, subcmpnyName
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const [autoassign, setAutoassign] = useState(false);
  const [assigndriverModal, setAssigndriverModal] = useState(false);
  const [dialogFormValues, setDialogFormValues] = useState({});

  const handleautoassign = () => {
    setAutoassign((prev) => !prev);
  };

  const handleCloseassignModal = () => {
    setAssigndriverModal(false);
  };


  
  const handledisagreeassignModal = () => {
    setAssigndriverModal(false);
  }

  const handlecreatetrip = (formValues) => {
    //console.log('activecarouselservice-->',activecarouselRef);
    formValues.bookingType = "USER";
    formValues.d_address = destination;
    formValues.d_latitude = dropLatLng.lat;
    formValues.d_longitude = dropLatLng.lng;
    formValues.distance = distance;
    formValues.minutes = travelDuration;
    formValues.s_address = origin;
    formValues.s_latitude = pickupLatLng.lat;
    formValues.s_longitude = pickupLatLng.lng;
    formValues.service_type = activecarouselRef.current?.service_id;
    formValues.estimatedFare = activecarouselRef.current?.estimated_fare;
    formValues.autoassigndriver = autoassign;
    formValues.userType = userType;
    formValues.subcmpnyName = subcmpnyName;
    formValues.isScheduled = formValues.isScheduled;
    formValues.scheduledTime = formValues.scheduledTime;

    // console.log('formValues-->',formValues);
    dispatch(showLoader("Loading please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Ride created successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik.resetForm();
        navigate('/triplist');
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while creating ride",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      formik.resetForm();
      const pickupInput = document.getElementById("pickuplocation");
      const dropInput = document.getElementById("droplocation");

      if (pickupInput) {
        pickupInput.value = ""; // Clear the value of the pickup location field
      }

      if (dropInput) {
        dropInput.value = ""; // Clear the value of the drop location field
      }
    };
    if (formValues.autoassigndriver) {
      DispatcherApi.createridebydispatcher({ ...formValues }).then(onSuccess, onFailure);
    }
    else {
      setDialogFormValues(formValues);
      setAssigndriverModal(true);
    }
  };

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      mobile: "0",
      promo_code: "",
      provider_id: "",
      service_type: "",
      s_latitude: "",
      s_longitude: "",
      s_address: "",
      d_latitude: "",
      d_longitude: "",
      d_address: "",
      distance: "",
      minutes: "",
      bookingType: "",
      userNotes: "",
      countryCode: "+44",
      isScheduled: false,
      scheduledTime: "",
    },
    validationSchema: yup.object({
      first_name: yup.string().required("First Name is required").nullable(),
      countryCode: yup.string().required("Country Code is required").nullable(),
      email: yup
        .string()
        .email("Invalid email format")
        .required("Email is required")
        .nullable(),
      mobile: yup
        .string()
        .matches(/^\d{1,15}$/, "Invalid mobile number")
        .required("Mobile is required")
        .nullable(),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      handlecreatetrip(values); // Ensure this processes `values` correctly
    },
  });

  useEffect(() => {
  if (formik.values.isScheduled) {
    setAutoassign(true);
  }else{  
    setAutoassign(false);

  }
  console.log(autoassign);
}, [formik.values.isScheduled]);

  return (
    <>
      <Grid container rowSpacing={1} className={classes.containerformik} >


        <Grid item xs={12} className={classes.switchWrapper}>
          <Grid item lg={5}>

            <Typography variant="body1">
              Schedule Ride
            </Typography>
          </Grid>
          <Grid item lg={7}>

            <FormControlLabel
              control={
                <CustomSwitch
                  checked={formik.values.isScheduled}
                  onChange={(e) => formik.setFieldValue("isScheduled", e.target.checked)}
                />
              }
            />
          </Grid>
        </Grid>

        {formik.values.isScheduled && (
          <Grid item xs={12} className={classes.formikgrids}>
            <TextField
              id="scheduledTime"
              label="Schedule Date & Time"
              type="datetime-local"
              value={formik.values.scheduledTime}
              onChange={formik.handleChange}
              fullWidth
              variant="standard"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        )}

        <Grid item xs={6} className={classes.formikgrids} >
          <TextField
            inputProps={{
              disableUnderline: false,
              form: {
                autocomplete: 'off',
              },
            }}
            id="first_name"
            label="First Name"
            value={formik?.values?.first_name}
            defaultValue={formik?.values?.first_name}
            onChange={formik.handleChange}
            error={
              formik?.errors?.first_name &&
              formik?.touched?.first_name
            }
            helperText={
              formik?.errors?.first_name &&
              formik?.touched?.first_name &&
              formik?.errors?.first_name
            }
            fullWidth
            variant="standard"
            size="small"
          ></TextField>
        </Grid>
        <Grid item xs={6} className={classes.formikgrids}>
          <TextField
            inputProps={{
              disableUnderline: false,
              form: {
                autocomplete: 'off',
              },
            }}
            id="last_name"
            label="Last Name"
            value={formik?.values?.last_name}
            defaultValue={formik?.values?.last_name}
            onChange={formik.handleChange}
            error={
              formik?.errors?.last_name &&
              formik?.touched?.last_name
            }
            helperText={
              formik?.errors?.last_name &&
              formik?.touched?.last_name &&
              formik?.errors?.last_name
            }
            fullWidth
            variant="standard"
            size="small"
          ></TextField>
        </Grid>
        <Grid item xs={12} className={classes.formikgrids} >
          <TextField
            inputProps={{
              disableUnderline: false,
              form: {
                autocomplete: 'off',
              },
            }}
            id="email"
            label="Email"
            value={formik?.values?.email}
            defaultValue={formik?.values?.email}
            onChange={formik.handleChange}
            error={
              formik?.errors?.email &&
              formik?.touched?.email
            }
            helperText={
              formik?.errors?.email &&
              formik?.touched?.email &&
              formik?.errors?.email
            }
            fullWidth
            variant="standard"
            size="small"
          ></TextField>
        </Grid>
        <Grid item xs={6} className={classes.formikgrids}>
  <TextField
    id="countryCode"
    name="countryCode"
    label="Country Code"
    select
    value={formik.values.countryCode}
    onChange={(e) => {
      const code = e.target.value;

      formik.setFieldValue("countryCode", code);

      // GB (+44)
      if (code === "+44") {
        formik.setFieldValue("mobile", "0");
      } else {
        formik.setFieldValue("mobile", "");
      }
    }}
    variant="standard"
    size="small"
    sx={{ width: "150px" }}
    error={
      formik.touched.countryCode &&
      Boolean(formik.errors.countryCode)
    }
    helperText={
      formik.touched.countryCode &&
      formik.errors.countryCode
    }
  >
    {countryCodeData?.map((country) => (
      <MenuItem
        key={country.code}
        value={country.dial_code}
      >
        {`${country.code} (${country.dial_code})`}
      </MenuItem>
    ))}
  </TextField>
</Grid>
     <Grid item xs={6} className={classes.formikgrids}>
  <TextField
    id="mobile"
    name="mobile"
    label="Mobile"
    variant="standard"
    size="small"
    fullWidth
    value={formik.values.mobile}
    onChange={(e) => {
      let value = e.target.value.replace(/\D/g, "");

      if (formik.values.countryCode === "+44") {
        // Always start with 0
        if (value.length > 0 && value[0] !== "0") {
          value = "0" + value;
        }

        // Maximum 11 digits
        value = value.slice(0, 11);
      } else {
        // Other countries - maximum 10 digits
        value = value.slice(0, 10);
      }

      formik.setFieldValue("mobile", value);
    }}
    inputProps={{
      maxLength: formik.values.countryCode === "+44" ? 11 : 10,
      inputMode: "numeric",
      pattern: "[0-9]*",
      autoComplete: "off",
    }}
    error={formik.touched.mobile && Boolean(formik.errors.mobile)}
    helperText={formik.touched.mobile && formik.errors.mobile}
  />
</Grid>
        <Grid item xs={12} className={classes.formikgrids}>
          <TextField
            inputProps={{
              disableUnderline: false,
              form: {
                autocomplete: 'off',
              },
            }}
            id="userNotes"
            label="userNotes"
            value={formik?.values?.userNotes}
            defaultValue={formik?.values?.userNotes}
            onChange={formik.handleChange}
            error={
              formik?.errors?.userNotes &&
              formik?.touched?.userNotes
            }
            helperText={
              formik?.errors?.userNotes &&
              formik?.touched?.userNotes &&
              formik?.errors?.userNotes
            }
            fullWidth
            variant="standard"
            size="small"
          ></TextField>
        </Grid>
        <Grid item xs={12} className={classes.switchWrapper}>
          <Typography variant="body1">
            Autoassign driver
          </Typography>
          <FormControlLabel
            control={
              <CustomSwitch
                checked={autoassign}
                onChange={() => handleautoassign()}
                disabled={formik.values.isScheduled}
              />
            }
          />
        </Grid>

        <Grid item xs={12} className={classes.switchWrapper} >
          <Button variant="contained" onClick={formik?.handleSubmit}>
            Create trip
          </Button>
        </Grid>

        <Assigndriver
          userType={userType}
          subcmpnyName={subcmpnyName}
          openDialog={assigndriverModal}
          formvalues={dialogFormValues}
          handleClose={handleCloseassignModal}
          handledisagree={handledisagreeassignModal}
        ></Assigndriver>

      </Grid>
    </>
  );
};

export default CreateTrip;